"use client"

const comparisonRows = [
    {
        feature: "Presale Launch Fee",
        tks: "Lower flat fee",
        competitor: "1 BNB + 5% of raised funds",
        tksBetter: true,
    },
    {
        feature: "Token Creation",
        tks: "No-code factory, lower cost",
        competitor: "0.4 BNB per token",
        tksBetter: true,
    },
    {
        feature: "Presale % Fee",
        tks: "No percentage cut on raised funds",
        competitor: "5% of all crypto raised",
        tksBetter: true,
    },
    {
        feature: "Multi-Chain Support",
        tks: "BSC, Ethereum, Solana, TON, TRON & more",
        competitor: "Multi-chain but fragmented UX",
        tksBetter: true,
    },
    {
        feature: "Price Oracle",
        tks: "Chainlink decentralized price feeds",
        competitor: "Manual pricing",
        tksBetter: true,
    },
    {
        feature: "KYC & Audit",
        tks: "Built-in KYC + audit integration",
        competitor: "Paid add-on services",
        tksBetter: true,
    },
    {
        feature: "Referral System",
        tks: "5% built-in referral bonus",
        competitor: "No referral program",
        tksBetter: true,
    },
    {
        feature: "Token Locking",
        tks: "Free locking & vesting",
        competitor: "Free basic lock",
        tksBetter: null,
    },
    {
        feature: "Staking Platform",
        tks: "Multi-tier staking with up to 40% APY",
        competitor: "No native staking",
        tksBetter: true,
    },
    {
        feature: "Token Listing Directory",
        tks: "Built-in discovery hub for tokens & presales",
        competitor: "No listing directory",
        tksBetter: true,
    },
    {
        feature: "Custom Presale Pages",
        tks: "Fully customizable branded pages",
        competitor: "Template-based, limited branding",
        tksBetter: true,
    },
]

export function ComparisonSection() {
    return (
        <section className="py-20 md:py-28 bg-muted/20" id="why-tks">
            <div className="container">
                {/* Header */}
                <div className="mb-16 text-center">
                    <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
                        Why TokenKickstarter
                    </div>
                    <h2 className="mb-5 text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
                        TKS vs{" "}
                        <span className="bg-gradient-to-r from-primary via-primary to-primary/70 bg-clip-text text-transparent">
                            Competitors
                        </span>
                    </h2>
                    <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
                        See how TokenKickstarter compares to other launchpads.
                        Lower fees, better tools, and a stronger ecosystem.
                    </p>
                </div>

                {/* Comparison Table */}
                <div className="glass-card overflow-hidden max-w-4xl mx-auto">
                    {/* Table Header */}
                    <div className="grid grid-cols-[1fr_1fr_1fr] sm:grid-cols-[1.2fr_1fr_1fr] gap-0 border-b border-border/30">
                        <div className="p-4 sm:p-5 text-sm font-semibold text-muted-foreground">
                            Feature
                        </div>
                        <div className="p-4 sm:p-5 text-sm font-bold text-primary text-center border-x border-border/20 bg-primary/5">
                            TokenKickstarter
                        </div>
                        <div className="p-4 sm:p-5 text-sm font-semibold text-muted-foreground text-center">
                            Other Platforms
                        </div>
                    </div>

                    {/* Rows */}
                    {comparisonRows.map((row, index) => (
                        <div
                            key={row.feature}
                            className={`grid grid-cols-[1fr_1fr_1fr] sm:grid-cols-[1.2fr_1fr_1fr] gap-0 ${index < comparisonRows.length - 1 ? "border-b border-border/20" : ""
                                } group hover:bg-muted/30 transition-colors`}
                        >
                            <div className="p-4 sm:p-5 text-sm font-medium flex items-center">
                                {row.feature}
                            </div>
                            <div className="p-4 sm:p-5 text-sm text-center border-x border-border/10 bg-primary/[0.02] flex items-center justify-center gap-2">
                                {row.tksBetter && (
                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
                                )}
                                {row.tksBetter === null && (
                                    <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/40 shrink-0" />
                                )}
                                <span className={row.tksBetter ? "text-foreground font-medium" : "text-muted-foreground"}>
                                    {row.tks}
                                </span>
                            </div>
                            <div className="p-4 sm:p-5 text-sm text-center text-muted-foreground flex items-center justify-center">
                                {row.competitor}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom highlight */}
                <div className="mt-8 max-w-4xl mx-auto grid gap-4 sm:grid-cols-3">
                    <div className="glass-card p-5 text-center group hover:border-primary/30 transition-all">
                        <div className="text-2xl font-bold text-primary mb-1">0%</div>
                        <div className="text-xs text-muted-foreground">Percentage Fee on Raised Funds</div>
                    </div>
                    <div className="glass-card p-5 text-center group hover:border-primary/30 transition-all">
                        <div className="text-2xl font-bold text-primary mb-1">5+</div>
                        <div className="text-xs text-muted-foreground">Chains Supported & More Coming</div>
                    </div>
                    <div className="glass-card p-5 text-center group hover:border-primary/30 transition-all">
                        <div className="text-2xl font-bold text-primary mb-1">Built-in</div>
                        <div className="text-xs text-muted-foreground">KYC, Audit & Referrals</div>
                    </div>
                </div>
            </div>
        </section>
    )
}
